import { render, staticRenderFns } from "./Listagem.vue?vue&type=template&id=0ce23fa8&scoped=true"
import script from "./Listagem.vue?vue&type=script&lang=js"
export * from "./Listagem.vue?vue&type=script&lang=js"
import style0 from "./Listagem.vue?vue&type=style&index=0&id=0ce23fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce23fa8",
  null
  
)

export default component.exports